module.exports = __webpack_public_path__ + "static/media/seminar_prospect_12.2ae11c12.pdf";